import { Grid } from "@mui/material";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { callAPI, IsSmallScreen, Method } from "../../../commonFunctions/CommonFunctions";
import PermissionDenied from "../../../commonFunctions/PermissionDenied";
import { AllPermissions } from "../../../commonFunctions/PermissionManger";
import WSDataGrid, { IColumns } from "../../../Components/DataGrid/WSDataGrid";
import SwipeableDrawerForm from "../../../Components/DrawyerForm/DrawyerForm";
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";
import { resetDataComponent, storeDataComponent, updateDataComponent } from "../../../StateManagement/actions";
import ProductDrawyer from "./DrawyerPages/ProductDrawyer";
import ConfirmDialog, { useConfirmDialog } from "../../../Components/Confirmation/ConfirmDialog";

export const OverViewProduct: React.FC<any> = React.memo((props) => {
  const isMobile = IsSmallScreen();
  AllPermissions.getInstance();
  const { add, edit, remove, view } = AllPermissions.getProductPermission;

  const { open, title, onConfirm, handleClose, openConfirmDialog, } = useConfirmDialog();
  const { showMessage } = useSnackbar();
  const dispatch = useDispatch()
  const params = useParams();
  const [openF, setOpen] = React.useState(false);
  const id = params?.id;
  const { control, register, handleSubmit, setValue, reset } = useForm();
  const [resetLoad, setResetLoad] = useState(false)
  const [formComponent, setFormComponent] = useState<any>()
  const columns: IColumns[] = [
    {
      header: "Name",
      fieldName: "name",
      tooltip: true,
      type: 'default'
    },
    {
      header: "Code",
      fieldName: "code",
      tooltip: true,
      type: 'default',
      isHide: isMobile
    },
    {
      header: "Unit",
      fieldName: "unit",
      tooltip: true,
      type: 'default',
      isHide: isMobile
    },
    {
      header: "Price",
      fieldName: "unitPrice",
      tooltip: true,
      type: 'default'
    },
    {
      header: "Actions",
      fieldName: "actions",
      type: "action",
      actions: [edit ? "Edit" : undefined, remove ? "Delete" : undefined].filter(Boolean),
      actionCallback: (action, row) => handleAction(action, row),

    },
  ];
  const source = {
    url: "products/search",
    page: 1,
    pageSize: 10,
    filter: [],
    sort: [],
  };
  const handleAction = async (action: string, row: any) => {
    if (action === "Edit") {
      const form: any = <ProductDrawyer
        id="emailAdd"
        data={row}
        productId={row?.id}
        control={control}
        register={register}
        reset={reset}
        setValue={setValue}
        onCancel={() => { reset(); setOpen(false); setFormComponent(null) }}
      />
      setFormComponent(form)
      setTimeout(() => {
        setOpen(true)
      }, 10);
    } else if (action === "Delete") {
      openConfirmDialog("Delete this record?", () => handleDelete(row?.id))
    }

  }
  const handleDelete = async (id?: string | number) => {
    const response: any = await callAPI(`products`, Method.DELETE, null, id);
    dispatch(resetDataComponent('productsDealsGrid'));
    setResetLoad(true)
    if (response?.success) {
      showMessage(response?.message, "success")
    }
    else {
      showMessage(response?.message || 'Something went wrong', "error")
    }
    handleClose()

  };
  const handleProductData = async (data: any) => {
    try {
      dispatch(storeDataComponent('productSubmit', { loading: true }));
      const response: any = await saveData(data);
      if (response && response?.message) {
        dispatch(resetDataComponent('productsDealsGrid'));
        reset()
        setResetLoad(true)
        showMessage(response.message, response.success === true ? 'success' : 'error')
      } else if (response?.id) {
        dispatch(resetDataComponent('productsDealsGrid'));
        setResetLoad(true)
        showMessage('Product Created Successfully', 'success')
      }
    } catch (e: any) {
      showMessage(e.error);
      setResetLoad(false)
    }
    finally {
      dispatch(updateDataComponent('productSubmit', { loading: false }));
    }

  }
  const saveData = async (data: any) => {

    const request: any = {
      "name": data?.name || "",
      "unit": data?.unit || "",
      "unitPrice": data?.unitPrice || "",
      "code": data?.code || "",
      "tax": data?.tax || "",

    }
    if (data?.productId) {
      const updatedFields = {
        updatedFields: {
          "Name": data?.name || "",
          "Unit": data?.unit || "",
          "UnitPrice": Number(data?.unitPrice) || "",
          "Code": data?.code || "",
          "Tax": Number(data?.tax) || "",
        }
      }
      const response: any = await callAPI(`products`, Method.PUT, updatedFields, data?.productId);
      return response
    } else {
      const response: any = await callAPI("products", Method.POST, request);
      return response
    }
  }
  const handleProductsClick = () => {
    setOpen(true)
    const form: any =
      <ProductDrawyer
        id="productdrawyer"
        control={control}
        register={register}
        reset={reset}
        setValue={setValue}
        onCancel={() => { reset(); setOpen(false) }}
      />

    setFormComponent(form)
    setTimeout(() => {
      setOpen(true)
    }, 10);
  }

  return (
    <Grid>
      <Grid container spacing={2} sx={{ marginTop:0 }}>
        {view ? <Grid item xs={12}>
          <WSDataGrid
            id="productsDealsGrid"
            title="Products"
            columns={columns}
            source={source}
            addButton={add ? { label: "New", color: "secondary" } : undefined}
            onAddButtonClick={handleProductsClick}
            isAccordian={true}
          />
        </Grid>
          : <PermissionDenied />
        }
        <ConfirmDialog
          open={open}
          title={title}
          onConfirm={onConfirm}
          onClose={handleClose}
        />
      </Grid>
      <SwipeableDrawerForm anchor="right" title={'Products'}
        openForm={openF}
        formComponent={<form onSubmit={handleSubmit(handleProductData)}>
          {formComponent}
        </form>}
        onClose={() => { reset(); setOpen(false); setFormComponent(null) }}
      />
    </Grid>

  );
});
